export const formatCurrencyInput = (value: number | string | null | undefined): string => {
  if (value === null || value === undefined || value === "") return "";

  const numericValue =
    typeof value === "number" ? value : Number(String(value).replace(/\./g, "").replace(",", "."));

  if (Number.isNaN(numericValue)) return String(value);

  return numericValue.toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const formatCurrencyDigits = (value: string): string => {
  const digits = value.replace(/\D/g, "").replace(/^0+(?=\d)/, "");
  if (!digits) return "";

  const cents = digits.padStart(3, "0");
  const integerPart = cents.slice(0, -2);
  const decimalPart = cents.slice(-2);

  return `${Number(integerPart).toLocaleString("pt-BR")},${decimalPart}`;
};

export const parseCurrencyInput = (value: string): string => {
  const normalized = value.replace(/\./g, "").replace(",", ".").trim();
  const numericValue = Number(normalized);

  return Number.isNaN(numericValue) ? "" : numericValue.toFixed(2);
};
